import { getSupabase, getSession, getUserId } from './supabase-client.js';

const PENDING_INVITE_KEY = 'metis_invite_token';

export function getPendingInviteToken() {
  const hashMatch = location.hash.match(/^#\/invite\/([^/?#]+)/);
  if (hashMatch?.[1]) return hashMatch[1];
  return sessionStorage.getItem(PENDING_INVITE_KEY);
}

export function setPendingInviteToken(token) {
  if (token) sessionStorage.setItem(PENDING_INVITE_KEY, token);
  else sessionStorage.removeItem(PENDING_INVITE_KEY);
}

export function buildInviteUrl(token) {
  const base = `${window.location.origin}${window.location.pathname}`.replace(/\/$/, '');
  return `${base}/#/invite/${token}`;
}

export async function previewTripInvite(token) {
  const supabase = getSupabase();
  const { data, error } = await supabase.rpc('preview_trip_invite', { p_token: token });
  if (error) throw error;
  return data;
}

export async function listTripInvites(tripId) {
  const supabase = getSupabase();
  const { data, error } = await supabase
    .from('trip_invites')
    .select('id, email, display_name, avatar_emoji, role, token, expires_at, accepted_at, created_at')
    .eq('trip_id', tripId)
    .order('created_at', { ascending: false });
  if (error) throw error;
  return data ?? [];
}

export async function revokeTripInvite(inviteId) {
  const supabase = getSupabase();
  const { error } = await supabase.from('trip_invites').delete().eq('id', inviteId);
  if (error) throw error;
}

export async function createTripInvite({ tripId, instanceId, email, displayName, avatarEmoji = '👤', role = 'editor' }) {
  const session = await getSession();
  const userId = getUserId(session);
  if (!userId) throw new Error('Sessione non valida');

  const memberRole = role === 'journal' ? 'journal' : 'editor';
  const supabase = getSupabase();
  const { data, error } = await supabase
    .from('trip_invites')
    .insert({
      trip_id: tripId,
      instance_id: instanceId,
      email: email.trim().toLowerCase(),
      display_name: displayName.trim(),
      avatar_emoji: avatarEmoji,
      role: memberRole,
      created_by: userId,
    })
    .select('token, email, display_name, role, expires_at')
    .single();

  if (error) throw error;
  return {
    ...data,
    url: buildInviteUrl(data.token),
  };
}

export async function acceptTripInvite(token) {
  const supabase = getSupabase();
  const { data, error } = await supabase.rpc('accept_trip_invite', { p_token: token });
  if (error) throw error;
  return data;
}

export async function tryAcceptPendingInvite() {
  const token = getPendingInviteToken();
  if (!token) return null;

  const tripId = await acceptTripInvite(token);
  setPendingInviteToken(null);
  return tripId;
}
